import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import {type  FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import useGetAssetsList from '@hooks/FixedAssets/useGetAssetsList';
 
interface LinesProps {
  formik: FormikProps<any>;
  isUpdate?: boolean;
}

const DepreciationLines: React.FC<LinesProps> = ({ formik, isUpdate = false }) => {
  const { values, setFieldValue } = formik;
  const { i18n, t } = useTranslation();
  const { OptionsAssets, loading, error } = useGetAssetsList();

 
 
  const handleLineChange = (index: number, field: string, value: any) => {
    const updatedLines = [...values.transactionsLinesList];

    updatedLines[index] = {
      ...updatedLines[index],
      [field]: value
    };

    formik.setFieldValue('transactionsLinesList', updatedLines);
  };

  const handleAddLine = () => {
    const newLine: any = {
      // assetId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      assetId: null,
      amount: 0,
      currentCost: 0,
      removalCost: 0,
      newCost: 0,
      retirementType: '',
      description: ''
    };

    const currentLines = values.transactionsLinesList || [];

    // تأكد من أن `currentLines` هو مصفوفة قبل إضافة السطر الجديد
    setFieldValue('transactionsLinesList', [...currentLines, newLine]);
  };

  const handleDeleteLine = (index: number) => {
    const updatedLines = values.transactionsLinesList?.filter((_: any, i: number) => i !== index);
    setFieldValue('transactionsLinesList', updatedLines);
  };

  const TransactionsLineList: any[] = values.transactionsLinesList?.slice();

  return (
    <>
      <Loading loading={loading} error={error} Type='Dots'>
        <div className='mb-3'>
          <div className='row'>
            <div className='col-3'>
              <div className='mb-1 rounded-3 p-2 bg-inverse bg-opacity-10'>
                <div className='d-flex justify-content-around'>
                  <div className='fw-bold'>{t('Total')} :</div>
                  <div className='text-theme fs-5 fw-bold'>0000</div>
                </div>
              </div>
            </div>

            <div className='col-lg-6'></div>
            <div className='col-lg-3 text-end '>
              <div className='text-end mb-2'>
                <button type='button' className='btn btn-theme' onClick={handleAddLine}>
                  {t('إضافة أصـل')}
                </button>
              </div>
            </div>
          </div>

          <div className=''>
            <div
              className={`table-responsive rounded-2 text-center ${
                formik.errors.transactionsLinesList ? 'border-bottom border-2 border-danger' : ''
              } `}
            >
              <table className='table table-borderless  table-hover mb-0 '>
                <thead className='bg-theme bg-opacity-30'>
                  <tr>
                    <th className='align-middle' style={{ width: '3%' }}>
                      #
                    </th>
                    <th className='align-middle' style={{ width: '30%' }}>
                      {t('الأصل')}
                    </th>
                    <th className='align-middle' style={{ width: '10%' }}>
                      {t('التكلفة الحالية')}
                    </th>
                    <th className='align-middle' style={{ width: '10%' }}>
                      {t('التكلفة الجديدة')}
                    </th>
                    <th className='align-middle' style={{ width: '10%' }}>
                      {t('الفارق')}
                    </th>

                    <th className='align-middle' style={{ width: '35%' }}>
                      {t('ملاحظـات')}
                    </th>
                    <th className='align-middle text-end' style={{ width: '2%' }}></th>
                  </tr>
                </thead>

                <tbody className='fw-bold'>
                  {TransactionsLineList?.reverse()?.map((line: any, index: any) => {
                    const Index = values.transactionsLinesList?.length - 1 - index;

                    // const selectedItems = values.transactionsLinesList
                    //   ?.filter((_: any, idx: any) => idx !== Index) // استبعاد العنصر الحالي
                    //   ?.map((line: any) => line.transactionItemId)
                    //   ?.filter(Boolean); // إزالة القيم الفارغة

                    return (
                      <tr key={index}>
                        <td className='align-middle bg-theme bg-opacity-30 small'>
                          {values.transactionsLinesList?.length - index}
                        </td>

                        <td className='align-middle small'>
                          <Select
                            classNamePrefix='react-select'
                            className='w-100'
                            isSearchable
                            isClearable
                            options={OptionsAssets}
                            onChange={option =>
                              handleLineChange(
                                Index,
                                'assetId',
                                option === null ? null : option.value
                              )
                            }
                            value={
                              line.assetId === null
                                ? null
                                : OptionsAssets?.find(option => option.value === line.assetId)
                            }
                            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base: any) => ({
                                ...base,
                                zIndex: 9999
                              })
                            }}
                            formatOptionLabel={option => (
                              <div className='d-flex justify-content-between   '>
                                <div className=''>{option.label}</div>
                                <div className='text-theme fw-bold'>{'000'}</div>
                              </div>
                            )}
                          />
                        </td>
                        <td className='align-middle small'>
                          <input
                            type='text'
                            autoComplete='off'
                            className='form-control text-center px-0'
                            value={line.currentCost}
                            onChange={e =>
                              handleLineChange(Index, 'currentCost', Number(e.target.value))
                            }
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value.replace(/[^0-9]/g, '');
                            }}
                          />
                        </td>

                        <td className='align-middle small'>
                          <input
                            type='text'
                            autoComplete='off'
                            className='form-control text-center px-0'
                            value={line.newCost}
                            onChange={e =>
                              handleLineChange(Index, 'newCost', Number(e.target.value))
                            }
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value.replace(/[^0-9]/g, '');
                            }}
                          />
                        </td>
                        <td className='align-middle small'>
                          <input
                            type='text'
                            autoComplete='off'
                            className='form-control text-center px-0'
                            value={line.amount}
                            onChange={e =>
                              handleLineChange(Index, 'amount', Number(e.target.value))
                            }
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value.replace(/[^0-9]/g, '');
                            }}
                          />
                        </td>
                        <td className='align-middle small'>
                          <input
                            type='text'
                            autoComplete='off'
                            className='form-control text-center px-0'
                            value={line.description}
                            onChange={e => handleLineChange(Index, 'description', e.target.value)}
                          />
                        </td>

                        <td className='align-middle small'>
                          <button
                            type='button'
                            className='btn btn-outline-danger'
                            onClick={() => handleDeleteLine(Index)}
                          >
                            <i className='fas fa-trash-alt'></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default DepreciationLines;
